import React, { useState, useCallback } from 'react'
import { Box, IconButton } from '@mui/material'

import { Breadcrumbs } from '../Breadcrumbs'
import { Menu } from '../Menu'
import { Logo, Moon, Sun, Hamburger } from 'assets/icons'
import { getStoredThemeMode, applyThemeMode } from 'apps/utils/themeMode'

export const MobileHeader = ( { crumbs, isTablet, isMenuShown, toggleMenu } ) => {
	const [ themeMode, setThemeMode ] = useState( getStoredThemeMode )
	const toggleThemeMode = useCallback( () => {
		setThemeMode( prev => {
			const next = prev === 'dark' ? 'light' : 'dark'
			applyThemeMode( next )
			return next
		} )
	}, [] )

	return (
		<React.Fragment>
			<Box
				position='fixed'
				left='0'
				right='0'
				bgcolor='var(--bg)'
				zIndex='9'
			>
				<Box
					display='flex'
					alignItems='center'
					borderBottom='1px solid var(--line)'
					height='53px'
					padding='0 16px'
				>
					<Box height='36px' width='36px'>
						<Logo width='36px' />
					</Box>
					<Box marginLeft='auto' display='flex'>
						{ !isTablet &&
							<IconButton className='clear-btn' onClick={ toggleMenu }>
								<Hamburger width='36px' height='16px'/>
							</IconButton>
						}
						<Box onClick={ toggleThemeMode } role='button' className='theme-toggle' sx={{ cursor: 'var(--cursor-pointer)' }}>
							{ themeMode === 'dark'
								? <Sun className='sun-icon' viewBox='0 0 26 26' />
								: <Moon className='moon-icon' viewBox='0 0 26 26' />
							}
						</Box>
					</Box>
					{ isMenuShown && <Menu /> }
				</Box>
				{ crumbs && <Breadcrumbs crumbs={ crumbs } /> }
			</Box>
		</React.Fragment>
	)
}
